import type { FieldConfig, FieldValue } from '@shared/types/interactiveFields';
import { TextField } from './TextField';
import { TextareaField } from './TextareaField';
import { TelField } from './TelField';
import { EmailField } from './EmailField';
import { DateField } from './DateField';
import { SelectField } from './SelectField';
import { CheckboxField } from './CheckboxField';
import { TableField } from './TableField';

type Language = 'bg' | 'de' | 'en';

interface DynamicFieldRendererProps {
  field: FieldConfig;
  value: FieldValue;
  onChange: (value: FieldValue) => void;
  error?: string;
  disabled?: boolean;
  language: Language;
}

export function DynamicFieldRenderer({
  field,
  value,
  onChange,
  error,
  disabled,
  language,
}: DynamicFieldRendererProps) {
  switch (field.type) {
    case 'text':
      return (
        <TextField
          field={field}
          value={value as string}
          onChange={onChange}
          error={error}
          disabled={disabled}
          language={language}
        />
      );

    case 'textarea':
      return (
        <TextareaField
          field={field}
          value={value as string}
          onChange={onChange}
          error={error}
          disabled={disabled}
          language={language}
        />
      );

    case 'tel':
      return (
        <TelField
          field={field}
          value={value as string}
          onChange={onChange}
          error={error}
          disabled={disabled}
          language={language}
        />
      );

    case 'email':
      return (
        <EmailField
          field={field}
          value={value as string}
          onChange={onChange}
          error={error}
          disabled={disabled}
          language={language}
        />
      );

    case 'date':
      return (
        <DateField
          field={field}
          value={value as string}
          onChange={onChange}
          error={error}
          disabled={disabled}
          language={language}
        />
      );

    case 'select':
      return (
        <SelectField
          field={field}
          value={value as string | string[]}
          onChange={onChange}
          error={error}
          disabled={disabled}
          language={language}
        />
      );

    case 'checkbox':
      return (
        <CheckboxField
          field={field}
          value={value as boolean}
          onChange={onChange}
          error={error}
          disabled={disabled}
          language={language}
        />
      );

    case 'table':
      return (
        <TableField
          field={field}
          value={value as any[]}
          onChange={onChange}
          error={error}
          disabled={disabled}
          language={language}
        />
      );

    default:
      return null;
  }
}
